import { getStaticDocUrl } from "../utils/staticDocumentUrls"
import React from "react"

export const it_IT = {
  Retry: "Riprova",
  Continue: "Continua",
  "Secure payment": "Pagamento sicuro",
  "Payment validation": "Convalida del pagamento",
  "Validation de votre paiement en cours": "Convalida del tuo pagamento in corso",
  "Complete your payment with Aplazame.": "Completa il pagamento con Aplazame.",
  AplazameConfirmation: "Confirmation",
  "Complete your secure payment below.": "Completa qui sotto il tuo pagamento sicuro.",
  "Initializing secure payment...": "Inizializzazione del pagamento sicuro...",
  "Unable to load payment configuration. Please try again.":
    "Impossibile caricare la configurazione del pagamento. Riprova.",
  "Unable to start payment. Please try again.": "Impossibile avviare il pagamento. Riprova.",
  "Unable to submit payment. Please try again.": "Impossibile inviare il pagamento. Riprova.",
  "A problem occurred during finalization. You will be redirected shortly.":
    "Si e verificato un problema durante la finalizzazione. Verrai reindirizzato a breve.",
  "Retry failed. Please try again.": "Il nuovo tentativo non e riuscito. Riprova.",
  "Payment initialization is taking longer than expected. Please try again or contact support.":
    "L'inizializzazione del pagamento sta richiedendo piu tempo del previsto. Riprova o contatta il supporto.",
  Finalization: "Finalizzazione",
  "Bank card": "Carta bancaria",
  "Photo of your ID": "Foto del documento di identita",
  "Your photo": "La tua foto",
  /* ========================================== */
  /* COMMON =================================== */
  /* ========================================== */
  "Back to shop": "Torna al sito",
  "Redirecting to Samsung shop shortly": "Ti reindirizzeremo al Samsung Shop tra un istante.",
  Back: "Indietro",
  Validate: "Continua",
  "Your transaction is being finalized.": "La transazione è in fase di completamento.",
  button_cancel: "Annulla",
  button_close: "Chiudi",
  button_send_upload: "Invia",
  "Select...": "Selezionare...",
  Choose: "Seleziona",
  civility_mr: "Sig.",
  civility_mrs: "Sig.ra",
  ACKNOWLEDGMENT_RECEIPT: "Accusé de réception",
  OTHER: "Autre",
  DIAGNOSTIC_ASSESSMENT: "Bilan diagnostic",
  DELIVERY_FORM: "Modulo consegna",
  WAY_OUT_DOCUMENT: "Modulo consegna prodotto",
  RETURN_FORM: "Bon de restitution",
  WITHDRAWAL_FORM: "Bordereau de rétractation",
  COURIER: "Courrier",
  DISTRIBUTOR_INVOICE: "Fattura distributore",
  INVOICE: "Fattura distributore",
  ADDRESS_PROOF: "Justificatif de domicile",
  EXTERNAL_PAYMENT_PROOF: "Justificatif de paiement externe",
  SEPA_MANDATE: "Mandat SEPA",
  /* ========================================== */
  /* BREADCRUMB =============================== */
  /* ========================================== */
  Services: "Servizio di noleggio",
  Upfront: "Anticipo del contratto di noleggio",
  Informations: "Dati del cliente",
  Summary: "Riepilogo",
  Contracts: "Contratto",
  "My orders": "Ordini",
  Acceptance: "Accettazione",
  /* ========================================== */
  /* BASKET =================================== */
  /* ========================================== */
  Basket: "Ordine",
  Accessories: "Accessori",
  "Promo code": "Codice promo",
  on: "di",
  Offered: "Gratuito",
  "Shipping fees": "Consegna",
  Rent: "Canoni mensili",
  "/month": "/mese",
  months: " meses",
  months_uppercase: "Meses",
  YYYY: "AAAA",
  "MM/YYYY": "MM/AAAA",
  "YYYY/MM/DD": "GG/MM/AAAA",
  "DD/MM/YYYY": "GG/MM/AAAA",
  "including services pack at": "Riepologo servizi inclusi",
  "Renewal product": "Rinnovo del prodotto",
  "to product": "con il prodotto",
  Included: "Incluso",
  "Supporting documents requested": "Documenti da avere con sè",
  "A bank card in your name": "Carta di credito",
  "Your mobile phone": "Cellulare",
  "A bank identity statement in your name": "n/a",
  "My RIB": "n/a",
  "Your banking credentials": "Le sue credenziali bancarie (per recuperare il suo estratto conto)",
  "Mon relevé bancaire": "Il mio estratto conto",
  "A valid ID in your name": "Documento d’identità",
  "My ID": "n/a",
  "My valid ID": "n/a",
  "Proof of address of less than 3 months": "n/a",
  "Proof of address of less than 6 months": "n/a",
  "A mobile phone bill less than 6 months old in your name": "n/a",
  "Energy, telephone or internet bill in your name less than 6 months old": "n/a",
  "My proof of amount income": "n/a",
  "My proof of address": "n/a",
  /* ========================================== */
  /* SERVICES PAGE ============================ */
  /* ========================================== */
  "Summary of services included ":
    "Nollegia il prodotto da te scelto per la durata prevista a fronte di un canone mensile. L'offerta prevede l'accesso ai seguenti servizi.",
  "By continuing, you confirm that you have read the": "Continuando confermi di aver preso vision dell’",
  "privacy policy": "informativa sulla privacy",
  "the terms and conditions of the contract": "termini e condizioni del contratto",
  "the summary of the services included": "riepilogo dei servizi inclusi",
  "Summary of services included": "Riepilogo servizi inclusi",
  "penalties for contract":
    "Ricordati di restituire il prodotto in buone condizioni al termine del noleggio. La presenza di danni sullo stesso o la mancata restituzione comporta l’addebito di un importo a titolo di penale, come previsto dal contratto. Prendi visione delle penali associate al singolo prodotto, e i relativi importi, simulando direttamente le penalità associate.",
  "penalty calculation": {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        Clicca qui '{" "}
        <a href="https://www.personalrenting.com/calcolo-penali " target="_blank" rel="noopener noreferrer" alt="">
          simulare le penali
        </a>{" "}
        per simulare le penali
      </React.Fragment>
    )
  },
  "penalty click": "Clicca qui",
  "for simulation": "per simulare le penali",
  /* ========================================== */
  /* VALIDATION =============================== */
  /* ========================================== */
  Monsieur: "Maschio",
  Madame: "Femmnia",
  /* ========================================== */
  /* UPFRONT PAGE ============================= */
  /* ========================================== */
  "first installment of your rental contract": "Anticipo del contratto di noleggio",
  "Cards accepted": "Carte accettate",
  "Cards not accepted": "Carte non accettate",
  "Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.":
    "Carte di debito, prepagate e American Express",
  "This step only constitutes a request for authorization of payment.":
    "Questo passaggio è solo una richiesta di autorizzazione al pagamento.",
  " The 1st payment of ": " Il 1° pagamento di ",
  " by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    " con carta di credito sarà efficace solo dopo aver scaricato i documenti giustificativi e dopo aver firmato il contratto di noleggio. Se la tua richiesta di noleggio viene successivamente rifiutata dal locatore a seguito del suo studio, tale importo sarà immediatamente rimborsato.",
  "Upfront amount of your leasing contract": "Anticipo del contratto di noleggio",
  "Card number": "Numero carta",
  MM: "MM",
  "Your credit card is expired": "Carta è scaduta",
  "Expiration date": "Data scadenza",
  CVV: "CVV",
  "I, undersigned $ certify that I am the holder of the bank card used for the request for payment of my 1st payment.":
    [
      "Io sottoscritto ",
      " dichiaro di essere il titolare della carta di credito utilizzata per richiedere il pagamento del mio 1° pagamento."
    ],
  "the_first_payment_of $ will_be_accounted": [
    "Il prelievo di ",
    " € sarà addebitato solo al momento dell’accettazione della tua richiesta. Questa carta di credito verrà utilizzata per tutti i prelievi mensili."
  ],
  "Secured payment": "Pagamento sicuro",
  "validate the payment authorization": "Convalida l'autorizzazione al pagamento",
  "Your card has been declined. Please check the accuracy of the information entered. You can also contact your bank to verify that it is not blocking payment.":
    "La tua carta è stata rifiutata. Si prega di verificare l'esattezza delle informazioni inserite. Puoi anche contattare la tua banca per verificare che non stia bloccando il pagamento.",
  /* ========================================== */
  /* CLIENT DATA PAGE ========================= */
  /* ========================================== */
  "My identification": "Identificazione cliente",
  "Employment start date": "Data inizio lavoro",
  "Bank Seniority": "Anno apertura c/c bancario",
  "My identity": "Identità",
  "My coordinates": "Contatti",
  "My identity documents": "Documento identità",
  "My situation": "Situazione personale",
  Title: "Sesso",
  "Last name": "Cognome",
  "Maiden name": "Nome da nubile",
  "If you are not married, enter your name again.": "Se non sei sposato, inserisci di nuovo il tuo nome.",
  "First name": "Nome",
  "Tax number": "Codice fiscale",
  Address: "Indirizzo (Via, Numero civico)",
  "Enter the address that will appear on your contract.": "Inserisci l'indirizzo che apparirà sul tuo contratto.",
  Zip: "Codice postale",
  City: "Città",
  Province: "Provincia",
  Birthdate: "Data di nascita",
  "Identity document number": "Numero",
  "Number of driving license": "Retro patente",
  "Department of birth": "Provincia di nascita",
  "City of birth": "Comune di nascita",
  "Country of birth": "Paese di nascita",
  Citizenship: "Nationalità",
  citizenshipExtended: "Nazionalità",
  CitizenshipIT: "Cittadinanza",
  Mobile: "Cellulare",
  Landline: "Telefono Abitazione (facoltativo)",
  Email: "Email",
  "Identity document type": "Documento identità",
  "Place of issue": "Luogo di emissione",
  "Date of issue": "Data di emissione",
  "Permit, residence permit": "Permesso/carta di soggiorno",
  "Expiry residence permit date": "Scadenza permesso di soggiorno",
  "Temporary document": "Documento temporaneo",
  "Renewal request": "Richiesta rinnovo",
  "Indefinite period": "Tempo indeterminato",
  Occupation: "Professione",
  "Since...": "Dall'anno...",
  " since ": " dall'anno ",
  "Contract type": "Tipo di contratto",
  endContractDate: "Data di fine contratto",
  "Your net monthly income": "Reddito mensile in euro",
  "Company name": "Datore di lavoro",
  "Company city": "Città lavoro",
  "Company province": "Provincia lavoro",
  Housing: "Tipo di abitazione",
  "Family situation": "Stato Civile",
  /* ========================================== */
  /* SUMMARY ================================== */
  /* ========================================== */
  within: "da",
  "Edit my data": "Modifica i miei dati",
  "By clicking you confirm that you have read the privacy policy relating to your rental practice": {
    elementHtml: (props) => {
      const href = getStaticDocUrl(props?.tunnelData, "privacy", "https://static-it.evollis.com/privacy_it.pdf")
      return (
        <React.Fragment>
          {" "}
          Cliccando confermi la presa visione dell'{" "}
          <a href={href} target="_blank" rel="noopener noreferrer" alt="">
            informativa privacy
          </a>{" "}
          relativa alla tua pratica di noleggio
        </React.Fragment>
      )
    }
  },
  "We ask your consent for all the purposes described in data processing :":
    "Ti chiediamo il consenso per tutte le finalità descritte nel trattamento dei dati :",
  "Evaluation purposes for the rental, with transmission of any data from Findomestic Banca S.p.A.":
    "Finalità di valutazione per il noleggio, con trasmissione di eventuali dati di Findomestic Banca S.p.A.",
  "Market research, commercial communication with automated methods, on own and third party products and services.":
    "Ricerche di mercato, comunicazione commerciale con modalità automatizzate, su prodotti e servizi propri e di terzi.",
  "Communication or transfer of data to third parties for the purposes of commercial communication with traditional and automated methods, of their products and services.":
    "Comunicazione o cessione dei dati a terzi a fini di comunicazione commerciale con modalità tradizionali e automatizzate, di loro prodotti e servizi.",
  /* ========================================== */
  /* NETHEOS ================================== */
  /* ========================================== */
  "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.":
    "Leggi il contratto in ogni sua parte e inserisci i documenti richiesti tramite upload. Potrai accettare le condizioni del contratto spuntando le caselle e firmando digitalmente il contratto con un codice OTP che riceverai tramite SMS.",
  /* ========================================== */
  /* CONFIRMATION ============================= */
  /* ========================================== */
  "Request sent": "Richiesta inviata",
  "Your file number is": "Il tuo numero di file è ",
  "Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.":
    "Il tuo prodotto sarà spedito dopo l’approvazione della tua richiesta.",
  "Thank you for your trust and see you soon !": "Grazie per la fiducia e a presto !",
  /* ========================================== */
  /* ERROR PAGES ============================== */
  /* ========================================== */
  "Internal error": "Errore interno",
  "The server was unable to process your request.": "Il server non ha potuto elaborare la tua richiesta.",
  "The server has encountered an error, and couldn't treat your request.":
    "Il server ha riscontrato un errore e non è stato in grado di elaborare la tua richiesta.",
  "Page not found": "Pagina non trovata",
  "The page you're asking for doesn't exist or had been deleted":
    "La pagina che stai cercando non esiste o è stata cancellata.",
  "Service unavailable": "Servizio non disponibile",
  "Service is unavailable, please come back later.":
    "Il servizio non è temporaneamente disponibile. Per favore ritorna più tardi.",
  "Pending request": "Richiesta in sospeso",
  "You have 2 days to finalize your request by uploading your supporting documents.":
    "Il tuo ordine è in sospeso. Hai 3 giorni per finalizzarlo e caricare i tuoi documenti.",
  "We will send you an email allowing you to finalize your file later.":
    "A breve riceverai una mail con il link che ti permetterà di completare correttamente la tua richiesta.",
  "Without your supporting documents, your file will be canceled within 3 days.":
    "Il tuo ordine è in sospeso. Hai 3 giorni per finalizzarlo e caricare i tuoi documenti.",
  /* ========================================== */
  /* VALIDATION =============================== */
  /* ========================================== */
  Required: "Campo obbligatorio",
  "Enter data": "Inserire i dati",
  "Invalid data": "Dato non valido",
  "Date is not valid": "Data non valida",
  Maximum: "Massimo",
  characters: "caratteri",
  "maximum characters": "caratteri massimi",
  "Unauthorized characters": "Caratteri non autorizzati",
  "Phone number must start with 06 or 07 and contain 10 numbers":
    "Il numero di telefono deve iniziare con 06 o 07 e contenere 10 numeri",
  "Invalid phone number": "Dato non valido Formato 393xxxxxxxx",
  "Invalid format fixe phone": "Dato non valido Formato 0999999999",
  "Invalid postal code": "Dato non valido Formato 99999",
  "Invalid date in past": "La data non può essere nel passato",
  "Minimum age must be > 18 years old": "L'età minima deve essere> 18 anni",
  "Maximum age must be < 110 years old": "L'età massima deve essere <110 anni",
  "Must be positive": "Il numero deve essere positivo",
  "minimum characters": "caratteri minimi",
  "number of children must be contains between 0 and 10": "Il numero di bambini deve essere compreso tra 0 e 10",
  "birthDate is not valid": "Data di nascita non valida",
  "employmentDate cannot be before birthDate": "La data di assunzione non può essere antecedente alla data di nascita",
  "Year seniority bank cannot be before birth date": "La data non può essere precedente all’anno di nascita",
  "difference between employment date and birth date must be at least 16 years":
    "La differenza tra la data di assunzione e quella di nascita deve essere di almeno 16 anni",
  "difference between bank seniority date and birth date must be at least 16 years":
    "La differenza tra la data di anzianità bancaria e la data di nascita deve essere di almeno 16 anni",
  "employmentDate cannot be in future": "La data di assunzione non può essere futura",
  "Must be a whole number": "Deve essere un numero intero",
  "Must be a number": "Deve essere un numero",
  "Email invalid": "Dato non valido",
  "Please assert you're the real card owner":
    "Seleziona per confermare di essere il proprietario di questa carta di pagamento",
  "Not a valid MM value": "Mese in formato MM richiesto",
  "Not a valid YYYY date": "Anno nel formato AAAA richiesto",
  "Not a valid MM/YYYY date": "Data nel formato MM/AAAA richiesto",
  "Not a valid tax number": "Per favore verifica i dati inseriti",
  "Not a valid identity number": "Per favore verifica i  inseriti",
  "Not a valid date": "Data non valida",
  "Can't be before current year": "Non può essere prima dell'anno in corso",
  "Must be composed of 3 digits": "Deve essere di 3 cifre",
  "Must be composed of 12-19 digits": "Deve contenere 12-19 cifre",
  "Not a valid YYYY-MM-DD date": "Immettere una data nel formato GG/MM/AAAA",
  "Residence date cannot be before birth date": "La data non può essere precedente all’anno di nascita",
  "This date cannot be in future": "Questa data non può essere futura",
  "Employment date cannot be before birth date":
    "La data di assunzione non può essere antecedente alla data di nascita",
  "Employment date cannot be in future": "La data di assunzione non può essere futura",
  "Please pick a correct value": "Scegli un valore corretto",
  "Identity document / driving license number: invalid": "Numero documento d'identità/patente: Non valido",
  "Identity document issue date: Invalid date / DD / MM / YYYY format":
    "Data di emissione del documento di identità: Data non valida/Formato GG/MM/AAAA",
  "Not valid document": "Documento non valido",
  "Invalid format": "Dato non valido MM/AAAA",
  "Monthly income: Invalid ": "Reddito mensile: Non valido",
  "Patente elettronica, if I follow the rule which starts with U and I do not choose the correct city Roma, when I confirm the page, put the message":
    "Dato non valido",
  /* ========================================== */
  /* OK KO BACK =============================== */
  /* ========================================== */
  "Operation failed": "La tua richiesta non è riuscita",
  "Your order is canceled. The amount of the upfront will not be deducted from you.":
    "Il tuo ordine è stato annullato e l’importo dell’anticipo non è stato prelevato.",
  please_study_other_payment_means: " ",
  "Request denied": "Richiesta Rifiutata",
  "We regret to inform you that we cannot give a favorable response to your request.":
    "Ti informiamo che non possiamo accettare la tua richiesta.",
  Maintenance: "Manutenzione",
  "The app is temporarily unavailable.": "Il Servizio è temporaneamente non disponibile.",
  "Please come back later.": "La preghiamo di riprovare più tardi.",

  /* ========================================== */
  /* ORDER ================================== */
  /* ========================================== */
  "Contract start date": "Sottoscritto il",
  "Contract end date": "Termina il",
  "Contract renewal date": "Rinnovabile dal",
  "New Order": "Nuovo noleggio",
  "Renew Order": "Upgrade prodotto scelto",

  /* ========================================== */
  /* IDENTIFICATION ================================== */
  /* ========================================== */
  simulation_promotion_response_valid: {
    propsValues: (props) => {
      const { promotionCode } = props
      return `Il tuo codice promozionale “${promotionCode}” è stato applicato.`
    }
  },
  "Cliccando confermi la presa visione dell'informativa privacy relativa alla tua pratica di noleggio": {
    propsValues: (props) => {
      const hrefToDoc = getStaticDocUrl(
        props?.tunnelData,
        "privacy",
        props?.link || "https://static-it.evollis.com/privacy_it.pdf"
      )

      return (
        <React.Fragment>
          Cliccando confermi la presa visione dell'{" "}
          <a href={hrefToDoc} target="_blank" rel="noopener noreferrer" alt="">
            informativa privacy
          </a>{" "}
          relativa alla tua pratica di noleggio
        </React.Fragment>
      )
    }
  },
  SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT: {
    propsValues: (props) => {
      const hrefToDoc = getStaticDocUrl(
        props?.tunnelData,
        "privacy",
        props?.link || "https://static-it.evollis.com/privacy_it.pdf"
      )

      return (
        <React.Fragment>
          Cliccando confermi la presa visione dell'{" "}
          <a href={hrefToDoc} target="_blank" rel="noopener noreferrer" alt="">
            informativa privacy
          </a>{" "}
          relativa alla tua pratica di noleggio
        </React.Fragment>
      )
    }
  },
  yes: "Sì",
  no: "No",
  SmallBusiness: "Libero professionista con partita IVA",
  VatBusinessCode: "Partita IVA",
  "Invalid VAT Number": "Il codice Partita Iva non è corretto",
  SmallBusinessDescription: {
    propsValues: (props) => {
      return props?.text
    }
  },
  partitaIvaTooltipDescription: {
    propsValues: ({ description }) => {
      return description
    }
  },
  FirstParagraphSmallBusiness:
    "Seleziona questo campo solo se sei un libero professionista con Partita Iva al fine di accedere ai benefici fiscali relativi alle fatture dell’Anticipo del canone di noleggio e del canone mensile.",
  warningLabel: "Attenzione!",
  partitaIvaWarningdescription:
    "Il campo non è dedicato a Società di Capitali (Spa, Srl, Sapa, Srls), le Società di Persone (Società Semplice, Snc, Sas) o per ditta individuale",
  validator_invalidNetMounthlyIncomeFormat:
    "Formato del reddito mensile non valido : l’importo inserito non può essere inferiore a 10 €",
  validator_endContractDateInFuture: "La data di fine contratto deve essere futura",

  /* ========================================== */
  /* LOGIN ================================== */
  /* ========================================== */
  "Bad credentials": "La login e la password non sono corrette.",
  username: "Utente",
  password: "Password",
  connect: "Accedi",
  "need help": "Assistenza ?",
  "login page need help tooltip": "Se hai bisogno di assistenza contatta il 800 030 404",
  "User account is locked": "Il conto è bloccato. Contattare un amministratore per sbloccarlo.",

  one_lower_case_required: "Almeno un piccolo",
  one_upper_case_required: "Almeno una lettra maiuscola",
  one_number_required: "Almeno un numero o simbolo",
  more_than_height_length: "Almeno 8 caratteri",

  /* ========================================== */
  /* RESET PASSWORD  ========================== */
  /* ========================================== */
  password_expired: "Password scaduta",
  old_password: "Old password",
  new_password: "Nuova password",
  verify_new_password: "Conferma nuova password",
  change_password: "Aggiorna la tua password",
  confirmation_password_matches_new_password: "La nuova password è confermata",
  old_password_matches_current_password: "La tua password attuale non coincide con quella che hai inserito.",
  different_password: "Password diversa da quella attuale",

  /* ========================================== */
  /* PDI RETAIL ================================== */
  /* ========================================== */

  TOUS: "Tutti",
  WAIT_SIGNATURE: "Attesa firma",
  WAITING_DOCUMENTS: "Attesa documenti",
  REJECTED: "Rifiutata",
  PJ_UPLOADES: "In attesa di consegna documenti",
  ACCEPTED_AWAITING_FUNDING: "Da finanziare : Accepté",
  NOT_FINALIZED: "Non finalizzata",
  A_TRAITER_OCTROI: "Da studiare",
  REFUSED_AFTER_DOCUMENT_ANALYSIS: "Rifiutata dopo lo studio",
  DEFAULT: "Tutti",

  "En commande": "Ordine in corso",
  "A emporter": "Ritiro in negozio",
  "A emporter différé": "Ritiro differito",

  home_button_new: "Nuovo ordine/simulazione",
  home_button_new_description: "Inserimento nuova richiesta",
  home_button_takeover: "Mes simulations Nini",
  home_button_takeover_description: "Reprendre une simulation Nini",
  home_button_renewal: "Upgrade",
  home_button_renewal_description: "Upgrade contratti in corso",
  home_button_continue_order: "Lista pratiche",
  home_button_continue_order_description: "Pratiche in corso e da finalizzare",
  home_button_after_sales: "Supporto alle vendite",
  home_button_after_sales_description: "Gestisci i miei contratti, accedi agli strumenti",
  home_button_penalty_simulation: "Simulatore penalità",

  resume_order_load_search: "Ricerca in corso...",
  resume_order_success_search: "Ricerca completata",
  resume_order_error_search: "Errore durante la ricerca",
  resume_order_input_search_label: "Nome o numero dell'ordine",
  resume_order_fill_shipping_date_button_label: "Inserisci la data di consegna",
  previous: "Precedente",
  next: "Successivo",

  shop: "Punto vendita",
  search: "Ricerca",
  save: "Salva",
  identification_button_saveForLater: "Salva e continua dopo",
  search_no_result: "Nessun risultato",

  simulation_shop_block_title: "Punto vendita",
  simulation_shop_input_label: "Seleziona un Punto vendita",
  simulation_delivery_block_title: "Modalità di consegna",
  simulation_delivery_input_label: "Seleziona una modalità di consegna",
  simulation_products_block_title: "Prodotto",
  simulation_family_input_label: "Famiglia",
  simulation_category_input_label: "Categoria",
  simulation_price_input_label: "Prezzo",
  simulation_quantity_input_label: "Quantità",
  simulation_product_input_label: "Prodotto (riferimento o descrizione)",
  simulation_button_create_product: "+ Aggiungi",
  simulation_brand_input_label: "Marchio",
  simulation_description_input_label: "Descrizione",
  simulation_button_add_product: "+ Aggiungere un prodotto",

  simulation_promotion_block_title: "Promozione",
  simulation_promotion_input_label: "Codice promozionale",
  simulation_promotion_button_label: "Applica",
  simulation_promotion_response_invalid: "Non è stato possibile applicare il tuo codice promozionale.",

  simulation_button_reset: "Ripristina",
  simulation_button_update: "Calcola",

  create_product_inprogress_toast: "Creazione in corso...",
  create_product_success_toast: "Prodotto aggiunto",
  create_product_error_toast: "Errore nella creazione del prodotto",
  create_product_title: "Crea un nuovo prodotto",
  "has just been sent.": " E’ stato inviato.",
  error_voucher_retrieval: "Si è verificato un errore nel recupero del modulo consegna prodotto.",
  "No rental voucher": "Nessun modulo consegna prodotto disponibile.",
  upload_toast_fail: "Errore nel caricamento del documento : ",

  final_page_import_document: "Upload Modulo consegna prodotto",

  imei: "IMEI",
  bill_number: "Numero di fattura del prodotto",

  "Request pre-accepted": "RICHIESTA APPROVATA",
  "Pre accepted paragraph one": {
    elementHtml: <>La pratica di renting è stata completata.</>
  },
  "Pre accepted paragraph two": {
    elementHtml: <>Ricordati di:</>
  },
  "Pre accepted paragraph three": {
    elementHtml: <>Stampare e far firmare al cliente il Modulo consegna prodotto.</>
  },
  "Pre accepted paragraph four": {
    elementHtml: <>Consegnare l’originale del Modulo consegna prodotto al cliente.</>
  },
  "Pre accepted paragraph five": {
    elementHtml: <>Fare l'upload del Verbale di consegna firmato dal cliente</>
  },
  "Print the rental voucher": "STAMPA",
  generate_delivery_voucher: "OK",
  finalize_later: "Finire più tardi",
  pdi_retail_opl: "Numero ordine",
  pdi_retail_store_id_label: "Numero negozio",
  pdi_retail_partner_order_id_label: "Numero ordine distributore*",
  pdi_retail_imei_marquage_label: "Numero IMEI / marcatura",
  pdi_retail_mm_order_digits: "Inserire esattamente 8 cifre.",
  upload_file_title: "Upload documenti",
  upload_line_label: "Pagina",
  upload_button_line: "Scegli un file",
  upload_line_no_upload: "Nessun file selezionato",
  upload_button_add_document: "+ Aggiungi un documento",
  wrongFileExtensionMessage: "Questo file non è conforme, devi scegliere un'immagine o un pdf.",
  onlyAlphaNumericMessage: "Il nome deve contenere solo caratteri alfanumerici",
  fiveMegaBytesMaximumFileMessage: "n/a fiveMegaBytesMaximumFileMessage",
  upload_toast_success: "Upload eseguito correttamente",
  numero_marquage: "Numero di marcatura",

  /* ========================================== */
  /* SIMULATION FINAL PAGE ==================== */
  /* ========================================== */
  simulation_final_page_title: "Simulazione registrata",
  simulation_final_page_content: {
    propsValues: (props) => {
      const { simulationStorageTime } = props
      return (
        <>
          <p>La tua simulazione è stata salvata.</p>
          <p>
            Il tuo cliente ha ricevuto questa simulazione via e-mail con un link che gli permette di accedere al suo
            file di noleggio.
          </p>
          <p>
            Si prega di notare che questo collegamento è valido solo per un periodo di {simulationStorageTime} giorni.
          </p>
        </>
      )
    }
  },
  document_type: "Tipo di documento",
  retail_patch_order_success_label: "Il tuo documento è pronto per la stampa",
  start_by_searching_for: "Inizia facendo una ricerca...",
  loading_orders: "Caricamento file...",
  sort_by: "Ordina per",
  newest: "Più recente",
  oldest: "Più vecchio",
  filter_by: "Filtra per",
  remove_product: "Rimuovi il prodotto",
  change_identity_bloc_simplified_journey:
    "Se desidera modificare i dati presenti in “La mia identità”, la preghiamo di contattare il nostro servizio clienti al seguente indirizzo {adresse}",
  /* Algoan Bank Modal */
  algoanBankModal_loadingAria: "Caricamento",
  algoanBankModal_loadingText: "Recupero dei tuoi conti bancari...",
  algoanBankModal_errorMessage: "Si è verificato un errore. Riprova più tardi.",
  algoanBankModal_retry: "Riprova",
  algoanBankModal_titleSingle: "Il conto bancario su cui verranno addebitate le tue rate mensili.",
  algoanBankModal_titleMultiple: "Scegli il conto bancario su cui desideri che vengano addebitate le tue rate mensili.",
  algoanBankModal_continue: "Continua",
  algoanBankModal_noAccount: "Non siamo riusciti a identificare alcun conto bancario a tuo nome.",
  algoanBankModal_noAccountAdvice: "Esegui un nuovo percorso e utilizza un conto bancario di cui sei titolare.",
  /* Algoan Open Banking error codes */
  algoanBankModal_CURRENCY_NOT_SUPPORTED_title: "Valuta non supportata",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_message:
    "Non possiamo analizzare il tuo conto bancario perché la valuta del tuo conto non è compatibile con il nostro servizio. Utilizza un conto in euro.",
  algoanBankModal_NO_CHECKING_ACCOUNT_title: "Nessun conto corrente rilevato",
  algoanBankModal_NO_CHECKING_ACCOUNT_message:
    "Non abbiamo rilevato alcun conto corrente a tuo nome. Utilizza un conto bancario corrente per procedere con la richiesta.",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_title: "Tipo di conto sconosciuto",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_message:
    "Il tipo di conto bancario rilevato non è compatibile con la nostra analisi. Utilizza un conto bancario classico.",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_title: "Cliente non titolare (procura)",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_message:
    "Il conto bancario utilizzato non sembra essere a tuo nome. Utilizza un conto di cui sei titolare.",
  algoanBankModal_USAGE_NOT_SUPPORTED_title: "Conto professionale",
  algoanBankModal_USAGE_NOT_SUPPORTED_message:
    "I conti professionali non sono accettati. Utilizza un conto bancario personale.",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_title: "Transazioni insufficienti",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_message:
    "Non disponiamo di una cronologia bancaria sufficiente per analizzare la tua situazione. Utilizza un conto con transazioni recenti.",
  algoanBankModal_UNKNOWN_title: "Caso non identificato",
  algoanBankModal_UNKNOWN_message:
    "Si è verificato un errore durante l'analisi del tuo conto bancario. Riprova più tardi."
}
